export default __webpack_public_path__ + "static/media/Icon_Class_Worker.3104ce71.png";